<template>
  <div class="login-layout">
    <!-- <div class="login-layout-left">
      <div class="login-left-pic">
      </div>
    </div> -->
    <!-- <div class="login-layout-right"> -->
      <div class="login-form-layout">
        <h2 class="login-layout-title">账户登录</h2>
        <Form ref="formCustom" :model="formCustom" :rules="ruleCustom">
          <FormItem prop="account">
            <el-input
              type="text"
              v-model="formCustom.account"
              placeholder="输入邮箱"
              style="width:300px"
            ></el-input>
          </FormItem>
          <FormItem prop="passwd">
            <el-input
              type="password"
              v-model="formCustom.passwd"
              placeholder="输入登录密码"
              style="width: 300px"
            ></el-input>
          </FormItem>
          <FormItem>
            <el-button type="primary" size="large" @click="handleSubmit('formCustom')">登录</el-button>
          </FormItem>
          <FormItem>
            <p class="login-description">*暂不支持对外注册</p>
          </FormItem>
        </Form>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import VueCookie from "vue-cookie";
import Commons from '@/config/commons';

export default {
  name: "login",
  data() {
    const validateAccount = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please enter your account"));
      } else {
        callback();
      }
    };
    const validatePwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please enter your password"));
      } else {
        callback();
      }
    };

    return {
      formCustom: {
        account: "",
        passwd: ""
      },
      ruleCustom: {
        passwd: [{ validator: validatePwd, trigger: "blur" }],
        account: [{ validator: validateAccount, trigger: "blur" }]
      }
    };
  },
  mounted() {
    console.log('clear cookie and storage');
    const domain = {
      domain: Commons.getDomain()
    };
    sessionStorage.removeItem('localMenu')
    sessionStorage.removeItem('userName')
    sessionStorage.removeItem('userAccount')
    VueCookie.delete('USER_NAME', domain);
    this.$cookie.delete('WEBUI_SESSION_ID', domain);
    this.$cookie.delete('WEBUI_WEBAPI_TOKEN', domain);
    VueCookie.delete('WEBUI_SESSION_ID');
    VueCookie.delete('WEBUI_WEBAPI_TOKEN');
    VueCookie.delete("USER_NAME");
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let params = {
            name: this.formCustom.account,
            password: this.formCustom.passwd,
            setCookie: 1,
          };
          this.$axios.post("/passport/api/tools/login", params).then(response => {
            
            if (!response.data || response.data.rc != "0") {
              alert("账户或密码错误");
            } else {
              let token = response.data.session;
              let name = response.data.name;
              const domain = {
                domain: Commons.getDomain()
              };
              VueCookie.set("WEBUI_WEBAPI_TOKEN", token, domain);
              VueCookie.set("USER_NAME", name, domain);
              sessionStorage.setItem('userName', name);
              this.$router.push("/index");
              // window.location.href = this.$API.ROOT_URL;
            }
          });
        } else {
          // alert('no');
          //this.$Message.error('Fail!');
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "./fyd-style";
.login-layout{
  background-image: url('../assets/bg.png');
  background-size: 100% 100%;
}
.login-form-layout{
  // border: 1px solid red;
  background: #fff;
  padding: 36px;
  margin:  80px auto;
  // position: absolute;
  // bottom: 300px;
  // left: 42%;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  height: 400px;
  border-radius: 16px;
}
</style>



// WEBPACK FOOTER //
// Login.vue?626fc834